import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { CompanyStore, CompanyState } from './company.store';
import { Observable } from 'rxjs';
import { Company } from './models/company.model';

@Injectable({ providedIn: 'root' })
export class CompanyQuery extends QueryEntity<CompanyState> {
  constructor(protected store: CompanyStore) {
    super(store);
  }

  selectCompanies(): Observable<Company[]> {
    return this.selectAll();
  }

  selectCompany(companyId: number): Observable<Company | undefined> {
    return this.selectEntity(companyId);
  }

  /** returns all companies marked as favourite */
  selectFavouriteCompanies(): Observable<Company[]> {
    return this.selectAll({ filterBy: (company) => company.Favourite === true });
  }
}
